import { render, staticRenderFns } from "./InnIconButton.vue?vue&type=template&id=1a46e87f"
import script from "./InnIconButton.vue?vue&type=script&lang=js"
export * from "./InnIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports